import { color } from '@telus-uds/palette-allium'
import styled from 'styled-components'

export const AthensGrayDiv = styled.div`
  background-color: ${color.greyAthens};
`
export const GiftContentContainer = styled.div`
  margin-left: ${({ isMobile }) => (isMobile ? 0 : '1rem')};
`

export const GiftLabelContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: ${({ isMobile }) => (isMobile ? 0 : '0.5rem')};
`
